<template>
  <!-- Caso 1: Cliente NO registrado / Varios -> Solo muestra avatar o icono de WhatsApp -->
  <div v-if="esVarios" class="wa-dual-avatar-wrap wa-avatar-solo-wa" :class="`wa-dual-avatar-${size}`">
    <div class="wa-avatar-main" :class="{ 'wa-avatar-no-img-wa-full': !avatarWhatsapp }">
      <img
        v-if="avatarWhatsapp"
        :src="avatarWhatsapp"
        class="wa-avatar-img-main"
        alt="WhatsApp"
      />
      <i v-else class="mdi mdi-whatsapp wa-avatar-main-icon text-white"></i>
    </div>
  </div>

  <!-- Caso 2: Cliente registrado en el sistema -> Dual avatar (Sistema + Badge WhatsApp) -->
  <div v-else class="wa-dual-avatar-wrap" :class="`wa-dual-avatar-${size}`">
    <!-- Foto 1: Foto del Cliente en Sistema (Grande) -->
    <div class="wa-avatar-main" :class="{ 'wa-avatar-no-img-system': !avatarClienteSrc }">
      <img
        v-if="avatarClienteSrc"
        :src="avatarClienteSrc"
        class="wa-avatar-img-main"
        alt="Cliente Sistema"
        @error="errorFotoCliente = true"
      />
      <span v-else class="wa-avatar-text-main">{{ inicialMostrar }}</span>
    </div>

    <!-- Foto 2: Foto de Perfil WhatsApp (Pequeña superpuesta) -->
    <div class="wa-avatar-badge" :class="{ 'wa-avatar-no-img-wa': !avatarWhatsapp }">
      <img
        v-if="avatarWhatsapp"
        :src="avatarWhatsapp"
        class="wa-avatar-img-badge"
        alt="WhatsApp"
      />
      <i v-else class="mdi mdi-whatsapp wa-avatar-icon-wa"></i>
    </div>
  </div>
</template>

<script>
import { API } from "@/API.js";
import SistemaSrv from "@/services/SistemaSrv.js";

// Promesa compartida del ajuste "foto_cliente" (una sola petición para todos los avatares)
let ajusteFotoPromesa = null;
let ajusteFotoFecha = 0;
// Tiempo en que se reutiliza el ajuste antes de volver a consultarlo (así un cambio en Ajustes se refleja pronto)
const AJUSTE_FOTO_TTL_MS = 5000;

export default {
  name: "CmpDualAvatar",
  props: {
    avatarCliente: {
      type: String,
      default: null
    },
    idCliente: {
      type: [Number, String],
      default: null
    },
    avatarWhatsapp: {
      type: String,
      default: null
    },
    nombre: {
      type: String,
      default: ""
    },
    inicial: {
      type: String,
      default: ""
    },
    esVarios: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md" // 'sm' | 'md' | 'lg' | 'hero'
    }
  },
  data() {
    return {
      errorFotoCliente: false,
      controlFoto: null
    };
  },
  created() {
    // El ajuste se consulta una sola vez y se comparte entre todos los avatares
    if (!ajusteFotoPromesa || Date.now() - ajusteFotoFecha > AJUSTE_FOTO_TTL_MS) {
      ajusteFotoFecha = Date.now();
      ajusteFotoPromesa = SistemaSrv.ajustes(["foto_cliente"])
        .then(response => {
          const valor = response?.data?.foto_cliente ?? response?.foto_cliente;
          return !(valor === false || valor === 0 || valor === "0");
        })
        .catch(() => {
          ajusteFotoPromesa = null;
          return false;
        });
    }
    ajusteFotoPromesa.then(activo => {
      this.controlFoto = activo;
    });
  },
  watch: {
    idCliente() {
      this.errorFotoCliente = false;
    },
    avatarCliente() {
      this.errorFotoCliente = false;
    }
  },
  computed: {
    avatarClienteSrc() {
      if (!this.controlFoto || this.errorFotoCliente) return null;
      if (this.idCliente && !this.esVarios) {
        // Misma URL que ListadoClientes.vue
        const tk = localStorage.getItem("argusblack.token");
        const tam = this.size === "hero" ? "128x128" : "64x64";
        return `${API}/clientes/${this.idCliente}/foto?_tk=${tk}&foto=${tam}`;
      }
      return this.avatarCliente || null;
    },
    inicialMostrar() {
      if (this.inicial) return this.inicial;
      if (this.nombre && this.nombre.trim()) return this.nombre.trim().charAt(0).toUpperCase();
      return "C";
    }
  }
};
</script>
